export const TASKS = '/tasks';
export const LESSON = '/lesson';
export const DICTIONARY = '/dictionary';
export const PROGRESS = '/progress';
export const TARIFF = '/tariff';
export const PAYMENT = '/payment';
export const AUTH = '/auth';
export const USER_AGREEMENT = '/user-agreement';
export const SETTINGS = '/settings';
